import Video from 'src/components/MediaGallery/Video';
import Image from 'src/components/MediaGallery/Image';
import PDFViewer from 'src/components/MediaGallery/PDFViewer';
import PDFPreview from 'src/components/MediaGallery/PDFPreview';
import { buildImageUrl } from 'src/util/buildImageUrl';
import CaptionBlock from 'src/components/MediaGallery/CaptionBlock';

const MediaItem = ({
  src,
  onClick = () => {},
  type = '',
  thumbnail = '',
  fullDisplay = false,
  caption = '',
  isSinglePdf = false,
}) => {
  return (
    <span onClick={onClick} className="hover:cursor-pointer relative block h-full">
      {type === 'video' && (
        <Video src={buildImageUrl(src)} thumbnail={thumbnail} controls={fullDisplay} />
      )}
      {type === 'image' && <Image src={buildImageUrl(src)} />}
      {type === 'pdf' &&
        (fullDisplay ? <PDFViewer src={src} /> : <PDFPreview isSinglePdf={isSinglePdf} />)}

      {(type === 'video' || type === 'image') && caption && <CaptionBlock caption={caption} />}
    </span>
  );
};

export default MediaItem;
